import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import CouponUsersTrackComponent from '../../../Components/AdminComponents/CouponUsersTrack';
import {useParams} from 'react-router-dom';
import {setPageNumber, setPageSize} from '../../../Store/Actions/pageSize';
import {
  DefaultPaginationValues,
  queryString,
} from '../../../Util/commonUtility';
import {getAllCouponCodeUsers} from '../../../Store/Actions';
import {getAllEventsByQueryStringSearch} from '../../../Store/Actions/events';

const CouponUsersTrackContainer = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const {allCouponCodeUsers} = useSelector(({couponCodes}) => couponCodes);
  const {allEventsQueryData} = useSelector(({events}) => events);
  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.couponUsers,
  );

  const [couponUsersData, setCouponUsersData] = useState();
  const [couponMeta, setCouponMeta] = useState({});
  const [pagination, setPagination] = useState({
    page: DefaultPaginationValues.PAGE,
    pageCount: DefaultPaginationValues.PAGE_SIZE,
    totalPages: DefaultPaginationValues.TOTAL_PAGES,
    totalCount: 0,
  });
  const [sortParams, setSortParams] = useState({
    field: 'created_at',
    order: 'descend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (allCouponCodeUsers) {
      const data = allCouponCodeUsers?.data || {};
      setCouponUsersData(data?.eventRegistrations);
      setCouponMeta({
        coupon_code: data?.coupon_code || id,
        coupon_type: data?.coupon_type,
        apply_to_whole_cart: data?.apply_to_whole_cart,
        event_id: data?.event_id,
        event_name: data?.event_name,
        used_qty: data?.used_qty,
        qty: data?.qty,
        total_registrations: data?.total_registrations,
        total_checkouts: data?.total_checkouts,
        registration_status_stats: data?.registration_status_stats,
      });
      setPagination((prev) => ({
        ...prev,
        page: data?.currentPage ?? prev.page,
        pageCount: data?.pageCount ?? prev.pageCount,
        totalPages: data?.totalPage ?? prev.totalPages,
        totalCount: data?.totalCount ?? prev.totalCount,
      }));
    } else {
      fetchCouponUsers(searchValues);
    }
  }, [allCouponCodeUsers?.data?.eventRegistrations]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchCouponUsers(searchValues);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged, searchValues]);

  useEffect(() => {
    if (searchValues) {
      dispatch(setPageNumber('couponUsers', 1));
      setPagination((prev) => ({
        ...prev,
        page: 1,
        pageCount: prev.pageCount || 10,
      }));
      setPaginationAndSortChanged(true);
    }
  }, [searchValues]);

  useEffect(() => {
    if (allEventsQueryData?.forSearch) {
      const events = allEventsQueryData.forSearch?.data?.events || [];
      setEventsList(
        events.map((e) => ({
          value: e.id,
          label:
            e.id != null && e.name != null
              ? `${e.id} - ${e.name}`
              : e.name || String(e.id),
        })),
      );
      setFetching(false);
    }
  }, [allEventsQueryData?.forSearch]);

  const handlePaginationChange = (current, pageSize) => {
    dispatch(setPageSize('couponUsers', pageSize));
    dispatch(setPageNumber('couponUsers', current));
    setPagination((prev) => ({
      ...prev,
      page: current,
      pageCount: pageSize,
    }));
    setPaginationAndSortChanged(true);
  };

  const handleTableChange = (pagination, filter, sorter) => {
    setSortParams({
      field: sorter.field || 'created_at',
      order: sorter.order || 'descend',
    });
    setPaginationAndSortChanged(true);
  };

  const fetchCouponUsers = (searchValues) => {
    const sortField = sortParams.field || 'created_at';
    const sortOrder = sortParams.order || '';
    const searchQueryData = queryString(searchValues || {});
    dispatch(
      getAllCouponCodeUsers(
        {page: pagination.page, pageCount: pagination.pageCount},
        sortField,
        sortOrder,
        searchQueryData,
        id,
      ),
    );
  };

  useEffect(() => {
    if (id) {
      dispatch(
        getAllEventsByQueryStringSearch({page: 1, pagecount: 100}, '', '', ''),
      );
      fetchCouponUsers(searchValues);
    }
  }, [id]);

  return (
    <div>
      <CouponUsersTrackComponent
        allCouponCodeUsers={couponUsersData}
        couponMeta={couponMeta}
        paging={pagination}
        handlePaginationChange={(page, pageSize) => {
          handlePaginationChange(page, pageSize);
        }}
        handleTableChange={handleTableChange}
        sortParams={sortParams}
        handleSearch={(values) => fetchCouponUsers(values)}
        searchValues={searchValues}
        eventsList={eventsList}
        setEventsList={setEventsList}
        setFetching={setFetching}
        fetching={fetching}
        eventIdOptions={eventsList}
      />
    </div>
  );
};

export default CouponUsersTrackContainer;
